import { CrumbRecord } from "common/records/Crumb";
import { RootState } from "common/reducers";
import { List } from "immutable";

const rootKey = "common";

/**
 * Fetches the list of crumbs
 *
 * @param {RootState} state
 * @returns {List<CrumbRecord>} The list of breadcrumb records
 */
export const crumbs = (state: RootState, _props?: any): List<CrumbRecord> => state.getIn([rootKey, "crumbs"]);

/**
 * Fetches the hamburger menu state
 *
 * @param {RootState} state
 * @returns {boolean} Whether the hamburger menu is open
 */
export const hamburgerMenu = (state: RootState, _props?: any): boolean => state.getIn([rootKey, "hamburgerMenuOpen"]);

/**
 * Fetches the presentation mode state
 * @param {RootState} state
 * @returns {boolean} Whether the presentation mode is active
 */
export const presentationMode = (state: RootState, _props?: any): boolean =>
  state.getIn([rootKey, "presentationMode"], false);

/**
 * @param {RootState} state
 * @returns {boolean} Whether the sidebar menu is collapsed
 */
export const collapsedSidebarMenu = (state: RootState, _props?: any): boolean =>
  state.getIn([rootKey, "collapsedSidebarMenu"], false);
